import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { Client } from "@/savaradio/common"
export const initialLoading = {
  create: false,
  delete: false,
  update: false,
  get: false,
  find: false
}
export type IsLoading = Record<keyof typeof initialLoading, boolean>

const initialState: { value: Client[] | null, isLoading: IsLoading } = {
  value: null, isLoading: initialLoading
}

const clientSlice = createSlice({
  name: "client_slice",
  initialState,
  reducers: {
    append: (state, action: PayloadAction<Client>) => {
      if (!state.value) state.value = [action.payload]
      if (
        state.value &&
        !state.value.some(item => item._id === action.payload._id)
      ) state.value = [action.payload, ...state.value]
    },
    reset: (state, action: PayloadAction<Client[] | null>) => {
      state.value = action.payload
    },
    merge: (state, action: PayloadAction<Client>) => {
      if (state.value) state.value = state.value.map(client => {
        if (client._id === action.payload._id) return action.payload
        return client
      })
    },
    pop: (state, action: PayloadAction<Client>) => {
      if (state.value) state.value = state.value.filter(client => client._id !== action.payload._id)
    },
    setLoading: (state, action: PayloadAction<Partial<IsLoading>>) => {
      state.isLoading = {
        ...state.isLoading,
        ...action.payload
      }
    }
  }
})

export const { append, reset, pop, merge, setLoading } = clientSlice.actions
export const client_slice = clientSlice.reducer